export const NEUTRAL = {
    light: {
        canvas: '#F6F7F9',
        surface: '#FFFFFF',
        sidebar: '#F1F3F6',
        subtle: '#FAFBFC',
        hairline: '#E6E8EC',
        hairline2: '#EEF0F3',
        border: '#D5D9E0',
        text1: '#16181D',
        text2: '#5B6472',
        text3: '#667080',
        inverse: '#16181D',
    },
    dark: {
        canvas: '#0F1115',
        surface: '#16181D',
        sidebar: '#121419',
        subtle: '#1C1F26',
        hairline: '#262A33',
        hairline2: '#20242C',
        border: '#333844',
        text1: '#ECEEF2',
        text2: '#A3ABB8',
        text3: '#8B94A3',
        inverse: '#2A2F3A',
    },
};
/** Semantic colour (§3) — separate from the brand accent, never a substitute for it. */
export const SEMANTIC = {
    light: {
        success: { fg: '#167A4B', bg: '#E6F5EE' },
        warning: { fg: '#9A5B00', bg: '#FBF1DF' },
        error: { fg: '#C7362F', bg: '#FCEBEA' },
        info: { fg: '#1F5BD6', bg: '#E5F0FF' },
    },
    dark: {
        success: { fg: '#5FCB93', bg: '#16301F' },
        warning: { fg: '#E2A94A', bg: '#332816' },
        error: { fg: '#F08A84', bg: '#3A1F1E' },
        info: { fg: '#7FA6F5', bg: '#1A2740' },
    },
};
/**
 * The status ramp (§3) for lifecycle and deal stages, rendered as a dot + label. Light
 * values are the contract's; dark values are the semantic dark foregrounds where the
 * contract maps them (blue→info, amber→warning, green→success, red→error). Slate and
 * violet have no dark value in the contract: slate uses text-2 dark, violet the violet
 * avatar tone's dark foreground. Both are recorded as an assumption in docs/lanes/d.md.
 */
export const STATUS = {
    light: {
        slate: '#5B6472',
        blue: '#1F5BD6',
        violet: '#6D4AC9',
        amber: '#9A5B00',
        green: '#167A4B',
        red: '#C7362F',
    },
    dark: {
        slate: '#A3ABB8',
        blue: '#7FA6F5',
        violet: '#C3B0F0',
        amber: '#E2A94A',
        green: '#5FCB93',
        red: '#F08A84',
    },
};
/** The product default brand: the `sprocket` manifest, signup chrome, favicon. */
export const BRAND_DEFAULT = { primary: '#4451C9', secondary: '#0F8F7E' };
/** The fixed platform-staff brand for the admin console (§10, 2026-09-03 entry). */
export const BRAND_STAFF = { primary: '#4451C9', secondary: '#0F8F7E' };
/** The `northstar` demo brand every new screen is checked against alongside the default (§8). */
export const BRAND_NORTHSTAR = { primary: '#0F8F7E', secondary: '#4451C9' };
/**
 * Six deterministic avatar tints (§6 `NameAvatar`). Every light foreground clears AA on
 * its background. Values carried over from the retired `ui-sprocket` `avatarTone.ts`
 * (reviewed 2026-09-21: values unchanged, moved into tokens).
 */
export const AVATAR_TONES = [
    { bg: '#E3E6F8', fg: '#3A46B4', fgDark: '#A9B2F2' }, // indigo
    { bg: '#E6F5EE', fg: '#167A4B', fgDark: '#7DD3A6' }, // green
    { bg: '#FBF1DF', fg: '#9A5B00', fgDark: '#E8B36A' }, // amber
    { bg: '#EEE8FA', fg: '#6D4AC9', fgDark: '#C3B0F0' }, // violet
    { bg: '#E5F0FF', fg: '#1F5BD6', fgDark: '#8FB3F7' }, // blue
    { bg: '#ECEFF3', fg: '#5B6472', fgDark: '#B3BAC6' }, // slate
];
/** Alpha levels the brand derives into (§3): tint (active nav, focus ring) and tintSoft (selection). */
export const BRAND_ALPHA = {
    light: { tint: 0.1, tintSoft: 0.06 },
    dark: { tint: 0.2, tintSoft: 0.14 },
};
/** `action.hover` is the text colour at a whisper of alpha. */
export const HOVER_ALPHA = { light: 0.04, dark: 0.06 };
/** Minimum contrast the theme guarantees: AA for text, 3:1 for filled controls. */
export const CONTRAST = { text: 4.5, control: 3 };
//# sourceMappingURL=color.js.map